module.exports = __webpack_public_path__ + "static/palettte4-887b0d3b24121de6db3ff3c8280b0386.jpg";